import React from 'react'
import { useManageComputation } from '../RMAReturnItemInfo/hooks'
import { setQtyRange } from "./utils"
import { eligibleStatuses } from '../constant'
import QuantitySelectionWMO from '../RMAReturnItemInfo/component/ItemDetail/QuantitySelectionWMO'
import { Container, Heading } from "../style/ReturnQuantitySelectionWMO.css"

const ReturnQuantitySelectionWMO = (props) => {
  const {
    selectedPart,
    setReturnQuantity,
    ikey = 0,
    parts,
    submitSelect = false,
    buttonLabel,
    orderItems
  } = props

  const {
    order_item_id: itemOrderId,
    order_item_status: orderItemStatus = '',
    qty: orderQty,
    available_return_qty: qty,
    sku: partNumber,
    list: itemPrice,
    returnQty: returnQuantity,
    returnRequest = {},
  } = parts

  const {
    qtyRange, setSelectedQty, eligibleRMA, qtyToCompute
  } = useManageComputation({
    returnQuantity,
    qty,
    selectedPart,
    partNumber,
    returnRequest,
    eligibleStatuses,
    orderItemStatus,
    buttonLabel,
    submitSelect,
    orderQty,
    itemPrice,
  })

  const handleQtyChange = (quantity) => {
    if (orderItems.length) {
      let indexData = 0
      orderItems.forEach(itemData => {
        if (itemData.order_item_id === itemOrderId) {
          orderItems[`${indexData}`].returnQty = quantity
        }
        indexData += 1
      })
    }

    setReturnQuantity(parseInt(quantity, 10))
    setSelectedQty(parseInt(quantity, 10))
  }

  return (
    <Container>
      <Heading>
        How many of this item are you returning?
      </Heading>
      <QuantitySelectionWMO
        eligibleRMA={eligibleRMA}
        partNumber={partNumber}
        setQtyRange={setQtyRange}
        handleQtyChange={handleQtyChange}
        ikey={ikey}
        qtyRange={qtyRange}
        qtyToCompute={qtyToCompute}
      />
    </Container>
  )
}

export default ReturnQuantitySelectionWMO
